<template>
  <div>
      <b-row>
        <b-col lg="9">
          <b-row>
            <b-col style="margin: 32px">
              <!--modal button-->
              <b-button block variant="outline-primary" v-b-modal="'addPatientModal'">Add Patient</b-button>

<!-- add patient modal start-->
              <b-modal id="addPatientModal" size="lg" title="Enter Patient Information" hide-footer>

                <b-container fluid>
<!--                  <b-row align-h="center">-->
<!--                    <b-col>-->
<!--                      <img height="200" width="200" v-if="patientImage" v-bind:src="patientImage">-->
<!--                    </b-col>-->
<!--                  </b-row>-->
                  <b-row>
                    <b-col lg="12">
                      <b-form @submit="onSubmitCreate" @reset="onReset" v-if="show">
                        <!--      Patient     -->
                        <!--Image-->
<!--                        <b-form-group id="image_group" label="Image:" label-for="image" description="The patient image">-->
<!--                          <b-form-file-->
<!--                              v-model="form.image"-->
<!--                              placeholder="Choose an image or drop it here..."-->
<!--                              drop-placeholder="Drop image here..."-->
<!--                              accept="image/jpeg, image/jpg, image/png"-->
<!--                              v-on:change="onImageInput"-->
<!--                          ></b-form-file>-->
<!--                        </b-form-group>-->
                        <!--Name-->
                        <b-form-group id="name_group" label="Name:" label-for="name" description="The patient name">
                          <b-form-input id="name" v-model="form.name" type="text" placeholder="Enter name" :state="Boolean(form.name)" required></b-form-input>
                        </b-form-group>
                        <!--Age-->
                        <b-form-group id="age_group" label="Age:" label-for="age" description="The patient age">
                          <b-form-input id="age" v-model="form.age" type="number" placeholder="Enter age" :state="Boolean(form.age)" required></b-form-input>
                        </b-form-group>
                        <!--Gender-->
                        <b-form-group id="gender_group" label="Gender:" label-for="gender" description="The patient gender. 0 => male, 1 => female">
                          <b-form-select id="gender" v-model="form.gender" placeholder="Enter gender" v-bind:options="options.gender" :state="Boolean(form.gender)" required></b-form-select>
                        </b-form-group>

                        <!--Address-->
                        <b-form-group id="address_group" label="Address:" label-for="address" description="The patient address">
                          <b-form-input id="address" v-model="form.address" type="text" placeholder="Enter address"></b-form-input>
                        </b-form-group>

                        <!--Blood Group-->
                        <b-form-group id="blood_group_group" label="Blood Group:" label-for="blood group" description="The patient blood group">
                          <b-form-select id="blood_group" v-model="form.blood_group" v-bind:options="options.blood_group" :state="Boolean(form.blood_group)"></b-form-select>
                        </b-form-group>

                        <!--Blood Pressure-->
                        <b-form-group id="blood_pressure_group" label="Blood Pressure:" label-for="blood_pressure" description="The patient blood pressure">
                          <b-form-input id="blood_pressure" v-model="form.blood_pressure" type="text" placeholder="Enter blood pressure" :state="Boolean(form.blood_pressure)" required></b-form-input>
                        </b-form-group>
                        <!--Cholesterol Level-->
                        <b-form-group id="cholesterol_level_group" label="Cholesterol Level:" label-for="cholesterol_level" description="The patient cholesterol level">
                          <b-form-input id="cholesterol_level" v-model="form.cholesterol_level" type="text" placeholder="Enter cholesterol level" :state="Boolean(form.cholesterol_level)" required></b-form-input>
                        </b-form-group>
                        <!--Height-->
                        <b-form-group id="height_group" label="Height:" label-for="height" description="The patient height">
                          <b-form-input id="height" v-model="form.height" type="text" placeholder="Enter height"></b-form-input>
                        </b-form-group>
                        <!--Weight-->
                        <b-form-group id="weight_group" label="Weight:" label-for="weight" description="The patient weight">
                          <b-form-input id="weight" v-model="form.weight" type="text" placeholder="Enter weight"></b-form-input>
                        </b-form-group>

                        <b-row>
                          <div style="padding-right: 10px; padding-left: 15px; ">
                            <b-button type="submit" variant="primary">Submit</b-button>
                          </div>
                          <b-button type="reset" variant="danger">Reset</b-button>
                        </b-row>

                      </b-form>
                    </b-col>
                  </b-row>
                </b-container>

<!--                <b-card class="mt-3" header="Form Data Result">-->
<!--                  <pre class="m-0">{{ form }}</pre>-->
<!--                </b-card>-->

              </b-modal>
              <!--modal end-->
            </b-col>
          </b-row>
          <b-row>
           <b-col>
<!--             <widget>-->
<!--               <h3>About Me</h3>-->
<!--               <p>-->
<!--                 Efficiently myocardinate market-driven innovation via open-source alignments. Dramatically engage high-Phosfluorescently expedite-->
<!--                 impactful supply chains via focused results. Holistically . Compellingly supply just in time catalysts for change through..-->
<!--               </p>-->
<!--             </widget>-->
           </b-col>
          </b-row>
<!--add patient modal end-->


          <b-row>
            <b-col>
<!--table start-->
              <b-table
                  id="patient-table"
                  striped
                  :items="table.patientInfo"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
              >

                <template v-slot:cell(actions)="row">
                  <b-button v-b-modal.details-modal variant="outline-success" size="sm" @click="selectCurrentPatient(row.index)" class="mr-1">Details</b-button>
                  <b-button variant="outline-info" size="sm" @click="info(row.item, row.index)" class="mr-1" >Add Prescription</b-button>
                  <b-button v-b-modal.update-patient-modal variant="outline-danger" size="sm" @click="selectCurrentPatient(row.index)" class="mr-1" >Edit</b-button>
                </template>

              </b-table>
              <b-pagination
                  v-model="table.currentPage"
                  :total-rows="table.totalRows"
                  :per-page="table.perPage"
                  aria-controls="patient-table"
              ></b-pagination>
<!--table end-->

<!--Details Modal start-->
              <b-modal id="details-modal" title="Patient Information" ok-only>
                <p>Name: {{currentPatient.name}}</p>
                <p>Age: {{currentPatient.age}}</p>
                <p>Gender: {{currentPatient.gender}}</p>
                <p>Address: {{currentPatient.address}}</p>
                <p>Blood Group: {{currentPatient.blood_group}}</p>
                <p>Blood Pressure: {{currentPatient.blood_pressure}}</p>
                <p>Cholesterol Level: {{currentPatient.cholesterol_level}}</p>
                <p>Height: {{currentPatient.height}}</p>
                <p>Weight: {{currentPatient.weight}}</p>
              </b-modal>
<!--Details Modal end-->

<!--Update Patient Modal-->
              <b-modal id="update-patient-modal" size="lg" title="Update Patient Information" hide-footer>

                <b-container fluid>
                  <b-row align-h="center">
                      <img height="200" width="200" v-if="previewImageObject" v-bind:src="previewImageObject">
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <b-form @submit="onSubmitEdit" @reset="onReset" v-if="show">
                        <!--      Patient     -->
                        <!--Image-->
                        <b-form-group id="update_image_group" label="Image:" label-for="image" description="The patient image">
                          <b-form-file
                              v-model="patientImageFile"
                              placeholder="Choose an image or drop it here..."
                              drop-placeholder="Drop image here..."
                              accept="image/jpeg, image/jpg, image/png"
                              v-on:change="onImageInput"
                          ></b-form-file>
                        </b-form-group>
                        <!--Name-->
                        <b-form-group id="update_name_group" label="Name:" label-for="name" description="The patient name">
                          <b-form-input id="name" v-model="form.name" type="text" placeholder="Enter name" :state="Boolean(form.name)" required></b-form-input>
                        </b-form-group>
                        <!--Age-->
                        <b-form-group id="update_age_group" label="Age:" label-for="age" description="The patient age">
                          <b-form-input id="age" v-model="form.age" type="number" placeholder="Enter age" :state="Boolean(form.age)" required></b-form-input>
                        </b-form-group>
                        <!--Address-->
                        <b-form-group id="update_address_group" label="Address:" label-for="address" description="The patient address">
                          <b-form-input id="address" v-model="form.address" type="text" placeholder="Enter address"></b-form-input>
                        </b-form-group>
                        <!--Blood Group-->
                        <b-form-group id="update_blood_group_group" label="Blood Group:" label-for="blood group" description="The patient blood group">
                          <b-form-select id="blood_group" v-model="form.blood_group" v-bind:options="options.blood_group" :state="Boolean(form.blood_group)"></b-form-select>
                        </b-form-group>
                        <!--Blood Pressure-->
                        <b-form-group id="update_blood_pressure_group" label="Blood Pressure:" label-for="blood_pressure" description="The patient blood pressure">
                          <b-form-input id="blood_pressure" v-model="form.blood_pressure" type="text" placeholder="Enter blood pressure" :state="Boolean(form.blood_pressure)" required></b-form-input>
                        </b-form-group>
                        <!--Cholesterol Level-->
                        <b-form-group id="update_cholesterol_level_group" label="Cholesterol Level:" label-for="cholesterol_level" description="The patient cholesterol level">
                          <b-form-input id="cholesterol_level" v-model="form.cholesterol_level" type="text" placeholder="Enter cholesterol level" :state="Boolean(form.cholesterol_level)" required></b-form-input>
                        </b-form-group>
                        <!--Height-->
                        <b-form-group id="update_height_group" label="Height:" label-for="height" description="The patient height">
                          <b-form-input id="height" v-model="form.height" type="text" placeholder="Enter height"></b-form-input>
                        </b-form-group>
                        <!--Weight-->
                        <b-form-group id="update_weight_group" label="Weight:" label-for="weight" description="The patient weight">
                          <b-form-input id="weight" v-model="form.weight" type="text" placeholder="Enter weight"></b-form-input>
                        </b-form-group>

                        <b-row>
                          <div style="padding-right: 10px; padding-left: 15px; ">
                            <b-button type="submit" variant="primary">Submit</b-button>
                          </div>
                          <b-button type="reset" variant="danger">Reset</b-button>
                        </b-row>

                      </b-form>
                    </b-col>
                  </b-row>
                </b-container>

                <!--                <b-card class="mt-3" header="Form Data Result">-->
                <!--                  <pre class="m-0">{{ form }}</pre>-->
                <!--                </b-card>-->

              </b-modal>
<!--Update Patient Modal end-->

            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <div>
            <widget style="padding: 0px;">
              <img src="https://img.freepik.com/free-vector/doctor-character-background_1270-84.jpg?size=338&ext=jpg" class="img" alt="team">
              <widget>
                <div style="margin-top: 5px;">
                  <h3 class="textdecorationName">Dr.Zinia Zara</h3>
                  <p class="textmargin1px textColorBlue">Cardiology</p>
                  <span class="textColorBlue" >MBBS, M.D of Medicine</span>
                </div>
              </widget>
            </widget>
            <widget>
              <h3>Personal Info</h3>
              <ul>
                <li>Phone:<span class="margin-lf-2px">+ (123) 1800-567</span></li>
                <li>Office:<span class="margin-lf-2px">+ 88500-567</span></li>
                <li>E-mail:<span class="margin-lf-2px"><code>ziniazara@gmail.com</code></span></li>
                <li  style="display: inline; margin-right: 10px;">Social:
                  <ul  style="display: inline; margin-right: 10px; margin-left: 15px;">
                    <li  style="display: inline; margin-right: 10px;"><a href="#"><i class="fa fa-facebook-f"></i></a></li>
                    <li style="display: inline; margin-right: 10px;"><a href="#"><i class="fa fa-twitter"></i></a></li>
                    <li  style="display: inline; margin-right: 10px;"><a href="#"><i class="fa fa-skype"></i></a></li>
                  </ul>
                </li>
              </ul>
            </widget>
            <widget style="background-color: #1A86D0; ">
               <b-row>
                 <div style="margin-left: 12px; margin-right: 12px;  ">
                   <img src="../../../assets/images/figure1.png" alt="figure">
                 </div>
                 <div >
                   <h4 style="color: white;">Emergency Cases</h4>
                   <span style="color: white;">2-800-700-6200</span>
                 </div>
               </b-row>
            </widget>
          </div>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import {Form} from "vform/src";
import CreatePatientService from '@/services/general_user/create_patient.service';
import UpdatePatientService from '@/services/general_user/update_patient.service';
import FetchPatientService from '@/services/general_user/fetch_patient.service';
import ChangePatientImageService from '@/services/general_user/change_patient_image.service';
import {mapGetters} from "vuex";

export default {
  name: "Profile",
  computed: {
    ...mapGetters('generalUserAuth', ['getUser'])
  },
  mounted() {
    this.fetchPatients();
    console.log(this.table.patientInfo);
  },
  data(){
    return{
      doctor:{
        name: '',
        type: '',
        detail: '',
        education:[
          {
            year: '',
            degree: '',
            institute: ''
          },
          {
            year: '',
            degree: '',
            institute: ''
          },
          {
            year: '',
            degree: '',
            institute: ''
          }
        ],
        aboutme: '',
        phone: '',
        office: '',
        email: '',
      },
      form: new Form({
        name: '',
        age: null,
        gender: null,
        address: '',
        blood_group: '',
        blood_pressure: '',
        cholesterol_level: '',
        height: null,
        weight: null
      }),
      patientImageFile: null,
      previewImageObject: null,
      show: true,
      options: {
        blood_group: [
          {value: '', text: 'Select Blood Group', disabled: true},
          {value: 'A+', text: 'A+(ve)'},
          {value: 'A-', text: 'A-(ve)'},
          {value: 'B+', text: 'B+(ve)'},
          {value: 'B-', text: 'B-(ve)'},
          {value: 'O+', text: 'O+(ve)'},
          {value: 'O+', text: 'O-(ve)'},
        ],
        gender: [
          {value: null, text: 'Select Gender', disabled: true},
          {value: 0, text: 'Male'},
          {value: 1, text: 'Female'},
        ]
      },
      table: {
        patientInfo: [],
        fields: [
          {key: 'name', label: 'Name', sortable: true, class: 'text-center'},
          {key: 'age', label: 'Age', sortable: true, class: 'text-center'},
          {key: 'gender', label: 'Gender', sortable: true, class: 'text-center'},
          {key: 'blood_group', label: 'Blood Group', sortable: true, class: 'text-center'},
          {key: 'actions', label: 'Actions', sortable: true, class: 'text-center'},
        ],
        totalRows: 0,
        currentPage: 1,
        perPage: 3,
      },
      currentPatient: {}
    };
  },
  methods:{
    fetchPatients(){
      FetchPatientService.fetchPatient(this.getUser.id).then(response => {
        if(response.status == 200) {
          this.table.patientInfo = response.data;
          this.table.totalRows = response.data.length;
        }
        else{
          alert("Patient Info could not be Fetched!");
        }
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onImageInput(e){
      this.patientImageFile = e.target.files[0];
      const file = e.target.files[0];
      this.previewImageObject = URL.createObjectURL(file);
      console.log(this.patientImageFile);
    },
    changePatientImage(imageParameter){
      let formData = new FormData();
      formData.append('image', imageParameter);
      ChangePatientImageService.changePatientImage(formData, this.currentPatient.id).then(response => {
        if(response.status == 200) {
          alert("Patient Image Updated Successfully!");
        }
        else{
          alert("Patient Image could not be updated!");
        }
      })
    },
    createPatient(){
      CreatePatientService.createPatient(this.form).then(response => {
        if(response.status == 201) {
          alert("Patient created successfully!");
        }
        else{
          alert("Patient could not be created!");
        }
      })
    },
    updatePatient(){
      UpdatePatientService.updatePatient(this.currentPatient.id, this.form).then(response => {
        if(response.status == 200) {
          alert("Patient updated successfully!");
        }
        else{
          alert("Patient could not be updated!");
        }
      })
    },
    onSubmitCreate(evt) {
      evt.preventDefault();
      this.createPatient();
      this.fetchPatients();
    },
    onSubmitEdit(evt) {
      evt.preventDefault();
      this.updatePatient();
      if(this.patientImageFile !== null) this.changePatientImage(this.patientImageFile);
      this.fetchPatients();
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    selectCurrentPatient(arrayIndex) {
       this.currentPatient = this.table.patientInfo[arrayIndex];
    }
  }
}
</script>

<style scoped>
 .margintop{
   margin-top: 8px;
 }
 .img{
   height: 300px;
   width: 100%;
 }
 .textdecorationName{
   padding: 1px 0px 1px 1px;
   font-family: sans-serif;
   font-weight: bold;
 }
 .textmargin1px{
   margin-top: 1px;
 }
 .textColorBlue{
   color: #1A86D0;
   font-weight: bold;
 }
 .margin-lf-2px{
   margin-left: 10px;
 }
</style>